var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9396 11.3777C14.5628 11.7475 14.3476 12.2797 14.4014 12.848C14.4821 13.8222 15.3702 14.5349 16.3389 14.5349H18.0433V15.6083C18.0433 17.4756 16.5273 19.0001 14.6705 19.0001H4.37277C2.51595 19.0001 1 17.4756 1 15.6083V9.53749C1 7.67024 2.51595 6.14575 4.37277 6.14575H14.6705C16.5273 6.14575 18.0433 7.67024 18.0433 9.53749V10.8365H16.2313C15.729 10.8365 15.2715 11.0349 14.9396 11.3777Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.3493V6.22692C1 5.15347 1.65482 4.19725 2.65051 3.81839L9.77279 1.11222C10.8851 0.688255 12.0781 1.51817 12.0781 2.71791V6.14571",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9993 11.7567V13.615C18.9993 14.1111 18.6046 14.517 18.1023 14.535H16.3442C15.3754 14.535 14.4874 13.8224 14.4066 12.8482C14.3528 12.2799 14.5681 11.7477 14.9448 11.3778C15.2767 11.035 15.7342 10.8366 16.2365 10.8366H18.1023C18.6046 10.8547 18.9993 11.2605 18.9993 11.7567Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04297 9.97943H11.3221",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_icon.dc657c037438f00c6ddc2f23b1ecb1a3.svg";
export { ForwardRef as ReactComponent };